<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <h1 class="titulo-pagina">{{ 'PRODUCTO.LBL_PRODUCTOS' | translate}}</h1>
  </div>
</div>
<div class="grid">
  <div class="col-12 md:col-6 lg:col-6">
    <button type="button" pButton icon="fa fa-plus" (click)="crear()" *ngIf="menu.agregar"
      label="{{ 'BTN_AGREGAR' | translate}}"></button>
  </div>
  <div class="col-12 md:col-6 lg:col-6">
    <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
      (input)="dt.filterGlobal($event.target.value, 'contains')" [(ngModel)]="busqueda" (change)="setBusqueda()">
  </div>
</div>
<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <p-table [columns]="columnas" [loading]="carTabla" #dt [value]="productos" selectionMode="single"
             [rowHover]="true" styleClass="p-datatable-gridlines" responsiveLayout="scroll" [breakpoint]="'960px'"
             dataKey="idProducto" [paginator]="true" [rows]="10" paginatorPosition="bottom"
             [tableStyle]="{'min-width': '50rem'}">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
            class="text-center">
            {{col.header}}
            <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr [pSelectableRow]="row">
          <td>{{row.tipoProductoBancario}}</td>
          <td>{{row.codigo}}</td>
          <td>{{row.nombre}}</td>
          <td>{{row.fechaInicioVigencia | date:'dd-MM-yyyy'}}</td>
          <td>{{row.fechaFinVigencia | date:'dd-MM-yyyy'}}</td>
          <td>{{row.nombreTipoCupo}}</td>
          <td>{{row.nombreClasificacion}}</td>
          <td class="text-center">
            <div class="btn-group" role="group">
              <button type="button" class="p-button p-button-info btn btnDown" icon="fa fa-arrow-down"
                data-toggle="tooltip" title="{{'BTN_ABAJO' | translate}}" pButton (click)="changeorder(1,row)"
                *ngIf="maxorden>row.orden"></button>
              <button type="button" class="p-button p-button-info btn btnUp" icon="fa fa-arrow-up" data-toggle="tooltip"
                title="{{'BTN_ARRIBA' | translate}}" pButton (click)="changeorder(-1, row)"
                *ngIf="row.orden>minorden"></button>
            </div>
          </td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
          </td>
          <td class="text-center">
            <div class="btn-group" role="group">
              <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                title="{{'BTN_VISUALIZAR' | translate}}" pButton pRipple (click)="ver(row)"></button>
              <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                title="{{'BTN_EDITAR' | translate}}" pButton pRipple *ngIf="menu.editar" (click)="editar(row)"></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns.length" class="text-center">
            {{ 'MSG_NOHAYREGISTROS' | translate}}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog
  header="{{ 'PRODUCTO.LBL_SELECCIONESTIPOPRODUCTO' | translate }}"
  [(visible)]="mostrarDialogoNuevo"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [responsive]="true"
  modal="true"
  [contentStyle]="{ width: '800px' }"
  *ngIf="mostrarDialogoNuevo"
  class="overflow-y-unset"
>
  <form [formGroup]="formulario" novalidate (ngSubmit)="guardar()">
    <div class="ui-g form-group">
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <div class="div-form">
          <label>* {{ 'PRODUCTO.LBL_TIPOPRODUCTO' | translate }}</label>
          <p-dropdown id="idTipoProductoBancario" name="nomTipoProductoBancario" [options]="lisTiposProductos"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
                      [autoWidth]="false" formControlName="idTipoProductoBancario"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoProductoBancario.invalid">
            {{ 'PRODUCTO.LBL_TIPOPRODUCTO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
    </div>
    <div class="ui-g form-footer-buttons">
      <div class="form-group ui-g-12">
        <div >
          <a (click)="regresar()" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
          <button icon="fa fa-plus" label="{{ 'BTN_GUARDAR' | translate }}"
                  type="submit"
                  pButton></button>
        </div>
      </div>
    </div>
  </form>
</p-dialog>
